module.exports = __webpack_public_path__ + "img/선생님avatar.636d5ae4.png";